module.exports = __webpack_public_path__ + "static/media/seaweed 0.1.27635779.svg";